export const selectAllCalendarAvailability = (state) =>
  state.calendarAvailability.data;

export const selectCalendarAvailability = (propertyCode) => (state) =>
  state.calendarAvailability.data[propertyCode];
